import { Container, Divider } from "@material-ui/core";
import { Box, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteWithSearch,
  CurrencyDisplay,
  CurrencyNumberInput,
  CustomTable,
  DatePicker,
  FormLabel,
  ModalError,
  ModalSuccess,
  ModalTable,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  SwitchInput,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { calculateSingleTax, calculateTotalTax, getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatPayloadDate, getErrors } from "utils";
import { columnTableInvoiceSongDetail } from "../../../../Publisher/Invoice/Components/ConstantInvoice";

function FormComposerInvoice() {
  const classes = globalStyles();
  const { id } = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const isFirstLoad = useRef(true);
  const triggerFetch = useRef(false);
  const triggerCostAllocation = useRef(false);
  const skipFirstCostAllocation = useRef(true);
  const editMode = Boolean(id);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [payload, setPayload] = useState({
    invoice_number: "",
    reference: "",
    invoice_date: moment(),
    composer_id: 0,
    value: 0,
    notes: "",
    is_draft: false,
    tax_ids: [],
    selected_sales_invoice: [],
    cost_allocation_amount: 0,
  });
  const [submmiting, setSubmitting] = useState(false);
  const [remainingBalance, setRemainingBalance] = useState();
  const [searchComposer, setSearchComposer] = useState("");
  const [optionClient, setOptionClient] = useState([]);
  const [showTaxes, setShowTaxes] = useState(false);
  const isUsageInvoice = payload?.type === "usage";
  const selectedTaxes = payload?.tax_ids;
  const checkSelectedTaxes = selectedTaxes?.length > 0;
  const [dataTable, setDataTable] = useState([]);
  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [dataTableTaxes, setDataTableTaxes] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingTableModal, setLoadingTableModal] = useState([]);
  const [dataTableModal, setDataTableModal] = useState([]);
  const [tableModalTotalPage, setTableModalTotalPage] = useState(1);
  const [tableModalParams, setTableModalParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [selectedInvoiceDetail, setSelectedInvoiceDetail] = useState({
    sales_invoice_number: "",
    sales_invoice_id: 0,
    is_checked: false,
    selected_item_ids: [],
  });
  const [updateSource, setUpdateSource] = useState(null);
  const [loadingCostAllocation, setLoadingCostAllocation] = useState(false);
  const [unpaidCostAllocation, setUnpaidCostAllocation] = useState(0);

  const pageTitle = `${id ? "Edit" : "Create"} Composer Invoice`;
  const pageSubTitle = `${id ? "Edit" : "Create"} your transaction here`;
  const selectedCurrencyCode = "Rp";
  let totalTax = calculateTotalTax(selectedTaxes, payload.value);
  let totalRevenueAfterTax =
    payload.value +
    (showTaxes && totalTax) -
    (payload?.cost_allocation_amount || 0);
  const initialPayload = useRef(payload);
  const hasPayloadChanges =
    JSON.stringify(initialPayload?.current) !== JSON.stringify(payload);
  const hasChanges = !editMode ? hasPayloadChanges : false;
  const selectedInvoices = payload?.selected_sales_invoice || [];
  const watchParamsSalesInvoice = [
    tableParams,
    payload?.composer_id,
    payload?.value,
    payload?.selected_sales_invoice,
  ];
  const showCostAllocation =
    unpaidCostAllocation > 0 || payload?.cost_allocation_amount > 0;

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeTableParams = (value, key) => {
    setTableParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeTableModalParams = (value, key) => {
    setTableModalParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeCheckboxTaxes = (_, option) => {
    setPayload(prev => {
      const current = prev?.tax_ids || [];
      const isSelected = current.some(item => item.id === option.id);

      return {
        ...prev,
        tax_ids: isSelected
          ? current.filter(item => item.id !== option.id)
          : [...current, option],
      };
    });
    triggerCostAllocation.current = true;
  };
  const handleChangeCheckboxSalesInvoices = (_, option) => {
    setPayload(prev => {
      const current = prev?.selected_sales_invoice || [];
      const isSelected = current.some(
        item => item?.sales_invoice_id === option?.sales_invoice_id
      );
      return {
        ...prev,
        value: 0,
        selected_sales_invoice: isSelected
          ? current.filter(
              item => item?.sales_invoice_id !== option.sales_invoice_id
            )
          : [
              ...current,
              {
                sales_invoice_id: option?.sales_invoice_id,
              },
            ],
      };
    });
    setUpdateSource("checkbox");
    triggerFetch.current = true;
  };
  const handleChangeCheckboxSong = (_, option) => {
    setSelectedInvoiceDetail(prev => {
      const current = prev?.selected_item_ids || [];
      const isSelected = current.some(item => item === option?.item_id);
      return {
        ...prev,
        selected_item_ids: isSelected
          ? current.filter(item => item !== option.item_id)
          : [...current, option?.item_id],
      };
    });
  };
  const handleSubmitSong = () => {
    setSubmitting(true);
    setPayload(prev => {
      const current = prev?.selected_sales_invoice || [];
      const temp = selectedInvoiceDetail;

      const exists = current.find(
        item => item.sales_invoice_id === temp.sales_invoice_id
      );

      let updatedSalesInvoices;

      if (exists) {
        updatedSalesInvoices =
          temp?.selected_item_ids?.length > 0
            ? current.map(item =>
                item.sales_invoice_id === temp.sales_invoice_id
                  ? {
                      ...item,
                      selected_item_ids: temp.selected_item_ids || [],
                    }
                  : item
              )
            : current?.filter(
                item => item?.sales_invoice_id !== temp?.sales_invoice_id
              );
      } else {
        updatedSalesInvoices =
          temp?.selected_item_ids?.length > 0
            ? [
                ...current,
                {
                  sales_invoice_id: temp.sales_invoice_id,
                  selected_item_ids: temp.selected_item_ids,
                },
              ]
            : current;
      }

      return {
        ...prev,
        value: 0,
        selected_sales_invoice: updatedSalesInvoices,
      };
    });
    setModalVisible(false);
    setSubmitting(false);
    triggerFetch.current = true;
  };
  const handleChangeComposer = value => {
    const selectedComposer = value?.composer_id || 0;
    setPayload(prev => ({
      ...prev,
      composer_id: selectedComposer,
      value: 0,
      selected_sales_invoice: [],
    }));
    triggerFetch.current = true;
  };
  const handleChangeRevenue = (value, reason) => {
    handleChangePayload(value, "value");
    if (reason?.event?.type === "change") {
      setUpdateSource("value");
      triggerFetch.current = true;
      if (value < payload?.cost_allocation_amount) {
        handleChangePayload(0, "cost_allocation_amount");
      }
    }
  };
  const handleChangeCostAllocation = value => {
    if (value > unpaidCostAllocation) {
      handleChangePayload(unpaidCostAllocation, "cost_allocation_amount");
    } else if (value > payload.value + (showTaxes && totalTax)) {
      handleChangePayload(
        payload.value + (showTaxes && totalTax),
        "cost_allocation_amount"
      );
    } else {
      handleChangePayload(value, "cost_allocation_amount");
    }
  };
  const validatePayload = () => {
    const errors = [];
    const errorEmpty = err => `${err} can't be empty.`;

    if (payload?.dsp_id === 0) {
      errors.push(errorEmpty("Client Name"));
    } else if (payload?.songs?.length === 0 && isUsageInvoice) {
      errors.push(errorEmpty("Songs"));
    } else {
      Object.entries(payload).forEach(([key, value]) => {
        switch (key) {
          case "invoice_date":
            if (!value || value === "1970-01-01") {
              errors.push("Invoice date");
            } else if (
              value &&
              new Date(value).toString() === "Invalid Date" &&
              value !== "1970-01-01"
            ) {
              errors.push("Invoice Date - Invalid format");
            }
            break;
          case "invoice_number":
            if (!value) errors.push(errorEmpty("Invoice number"));
            break;

          case "tax_ids":
            if (!value?.length && showTaxes) errors.push(errorEmpty("tax_ids"));
            break;
          default:
            break;
        }
      });
    }
    setSubmitting(false);
    return errors;
  };

  const getEditDetail = async () => {
    const url = `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/edit/${id}`;
    try {
      setLoadingPage(true);
      const res = await axios.get(url, {
        headers,
      });
      const { data } = res?.data?.data;
      const requiredKeys = [
        "invoice_number",
        "reference",
        "invoice_date",
        "composer_id",
        "value",
        "notes",
        "is_draft",
        "selected_sales_invoice",
        "cost_allocation_amount",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      setPayload({
        ...filteredData,
        tax_ids: data?.selected_taxes,
      });
      setTableParams({
        ...tableParams,
        composer_id: data?.composer_id,
        revenue: data?.value,
      });
      setShowTaxes(data.selected_taxes.length > 0 ? true : false);
      setTimeout(() => {
        setUpdateSource("value");
        triggerFetch.current = true;
      }, 150);
    } catch (error) {
      ModalError(error);
    } finally {
      isFirstLoad.current = false;
      setLoadingPage(false);
    }
  };
  const getSalesInvoiceList = async () => {
    const { composer_id, value, selected_sales_invoice } = payload;
    const modifiedPayload = {
      ...tableParams,
      composer_id,
      revenue: (updateSource === "value" && value) || 0,
      selected_sales_invoice,
    };
    try {
      setLoadingTable(true);
      const res = await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/list-sales-invoice`,
        modifiedPayload,
        { headers }
      );
      const { meta, data } = res?.data;
      setDataTable(data?.sales_invoices);
      const pageCount = getTotalPage(meta?.total, tableParams?.size || 1);
      setTableTotalPage(pageCount);
      setPayload(prev => ({
        ...prev,
        ...(!value && { value: data?.total }),
        selected_sales_invoice: data?.selected_sales_invoice,
      }));
    } catch (error) {
      ModalError(error);
    } finally {
      triggerFetch.current = false;
      setLoadingTable(false);
    }
  };
  const debounceSalesInvoiceList = useCallback(
    debounce(() => {
      getSalesInvoiceList();
    }, 500),
    [watchParamsSalesInvoice]
  );
  const getSelectedInvoiceDetail = async () => {
    const { composer_id, value, selected_sales_invoice } = payload;
    const modifiedPayload = {
      ...tableModalParams,
      composer_id,
      revenue: value,
      selected_sales_invoice,
    };
    try {
      setLoadingTableModal(true);
      const res = await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/${
          editMode ? `${id}/` : ""
        }sales-invoice/${selectedInvoiceDetail?.sales_invoice_id}`,
        modifiedPayload,
        { headers }
      );
      const { meta, data } = res?.data;
      setDataTableModal(data);
      const pageCount = getTotalPage(meta?.total, tableModalParams?.size || 1);
      setTableModalTotalPage(pageCount);
    } catch (error) {
      ModalError(error);
    } finally {
      setLoadingTableModal(false);
    }
  };
  const debounceSelectedInvoiceDetail = useCallback(
    debounce(() => {
      getSelectedInvoiceDetail();
    }, 500),
    [tableModalParams]
  );
  const getComposerList = async () => {
    const url = `${hardBaseUrl}/publisher/transaction/v2/list-composer`;
    try {
      const res = await axios.get(url, { headers });
      const { data } = res?.data;
      const modifiedData = data?.map(item => ({
        ...item,
        id: item?.composer_id,
        label: item?.composer_name,
      }));
      setOptionClient(modifiedData);
    } catch (error) {
      ModalError(error);
    }
  };
  const getBalance = async composer_id => {
    const url = `${hardBaseUrl}/publisher/transaction/v2/balance/composer/${composer_id}`;
    try {
      const res = await axios.get(url, { headers });
      const { data } = res?.data;
      setRemainingBalance(data?.balance);
    } catch (error) {
      ModalError(error);
    }
  };
  const getCostAllocation = async composer_id => {
    const allocationPayload = {
      composer_id: composer_id,
      sales_invoices: selectedInvoices,
      tax_ids: payload?.tax_ids?.map(item => item?.id) || [],
    };
    try {
      setLoadingCostAllocation(true);
      const res = await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/cost-allocation/check`,
        allocationPayload,
        { headers }
      );
      const { data } = res?.data;
      if (editMode && skipFirstCostAllocation.current) {
        skipFirstCostAllocation.current = false;
      } else {
        handleChangePayload(
          data?.suggested_amount || 0,
          "cost_allocation_amount"
        );
      }
      setUnpaidCostAllocation(data?.unpaid_amount || 0);
    } catch (error) {
      ModalError(error);
    } finally {
      setLoadingCostAllocation(false);
      triggerCostAllocation.current = false;
    }
  };

  const getTaxesList = async () => {
    const url = `${hardBaseUrl}/transaction/v2/tax/payment`;
    try {
      const res = await axios.get(url, { headers });
      const { data } = res?.data;
      setDataTableTaxes(data);
    } catch (error) {
      ModalError(error);
    }
  };

  const handleSubmitPayload = async (e, isDraft = false) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const method = editMode ? axios.put : axios.post;
    const successMessage = `Composer Invoice has been successfully ${
      editMode ? "updated" : "created"
    }`;

    setSubmitting(true);
    const errors = validatePayload();
    const { invoice_date } = payload;

    const modifiedPayload = {
      ...payload,
      tax_ids: showTaxes ? selectedTaxes?.map(tax => tax?.id) : [],
      invoice_date: formatPayloadDate(invoice_date),
      is_draft: isDraft,
    };

    if (errors?.length) {
      ModalError(errors[0]);
      setSubmitting(false);
      return;
    }
    try {
      setLoadingPage(true);
      await method(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice${
          editMode ? `/${id}` : ""
        }`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess(successMessage).then(() => {
        history.push("/admin/composer-invoice");
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getComposerList();
    getTaxesList();
    if (editMode) getEditDetail();
  }, []);

  useEffect(() => {
    if (payload.composer_id) {
      getBalance(payload.composer_id);
    }
  }, [payload.composer_id]);
  useEffect(() => {
    if (triggerFetch.current || triggerCostAllocation.current) {
      if (payload.composer_id && selectedInvoices?.length > 0) {
        getCostAllocation(payload.composer_id);
      }
    }
  }, [
    payload.composer_id,
    selectedInvoices?.length,
    payload?.tax_ids,
    triggerFetch.current,
  ]);

  useEffect(() => {
    if (triggerFetch.current) {
      const isTyping = Boolean(payload?.value);
      if (isTyping) {
        debounceSalesInvoiceList();
        return () => {
          debounceSalesInvoiceList.cancel();
        };
      } else {
        getSalesInvoiceList();
      }
    }
  }, [watchParamsSalesInvoice, debounceSalesInvoiceList]);
  useEffect(() => {
    if (modalVisible) {
      const isTyping = Boolean(tableModalParams?.search);
      if (isTyping) {
        debounceSelectedInvoiceDetail();
        return () => {
          debounceSelectedInvoiceDetail.cancel();
        };
      } else {
        getSelectedInvoiceDetail();
      }
    } else {
      setSelectedInvoiceDetail({});
    }
  }, [tableModalParams, modalVisible]);

  useEffect(() => {
    const handleBeforeUnload = event => {
      if (hasChanges) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasChanges]);

  useEffect(() => {
    if (remainingBalance < totalRevenueAfterTax) {
      ModalError("Total Revenue After Tax is greater than Available Balance");
      handleChangePayload(0, "value");
    }
  }, [remainingBalance, totalRevenueAfterTax]);

  const filterSameKey = optionClient.filter(
    (item, index, self) =>
      index === self.findIndex(t => t.composer_id === item.composer_id)
  );

  const filterComposer = filterSameKey?.filter(item =>
    item?.composer_name?.toLowerCase()?.includes(searchComposer?.toLowerCase())
  );

  return (
    <Page className={classes?.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData(pageTitle)}
            backButton
          />
          <Divider className={classes?.divider} />
          <SectionLabel subTitle={pageSubTitle} />
          <Box
            component="form"
            border="1px solid #ebebeb"
            borderRadius="6px"
            p="24px"
            mt="16px"
          >
            <Grid container columnSpacing={2} rowSpacing={1} spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel label="Invoice Number" required />
                <TextInput
                  placeholder="Invoice Number"
                  value={payload?.invoice_number}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "invoice_number")
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Reference" />
                <TextInput
                  placeholder="Reference"
                  value={payload?.reference}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "reference")
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Date" required />
                <DatePicker
                  disabled
                  value={payload?.invoice_date}
                  onChange={date => handleChangePayload(date, "invoice_date")}
                  minDate={moment()}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Notes" />
                <TextInput
                  placeholder="Notes"
                  value={payload?.notes}
                  onChange={event =>
                    handleChangePayload(event?.target?.value, "notes")
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Composer" required />
                <AutoCompleteWithSearch
                  placeholder="Composer"
                  options={filterComposer}
                  uniqueKey="id"
                  value={
                    optionClient.find(
                      option => option.id === payload?.composer_id
                    ) || null
                  }
                  onInputChange={value => setSearchComposer(value)}
                  isOptionEqualToValue={(option, value) =>
                    option?.composer_id === value?.composer_id ||
                    option?.id === value?.id
                  }
                  inputValue={searchComposer}
                  onChange={handleChangeComposer}
                  optionLabel="composer_name"
                  size="small"
                  width="100%"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Total" required />
                <CurrencyNumberInput
                  disabled={!payload?.composer_id}
                  placeholder="Total"
                  value={payload?.value || 0}
                  startAdornment="Rp"
                  onChange={handleChangeRevenue}
                />
                <Grid justifyContent="flex-start" display="flex">
                  <FormLabel label="Available Balance : " />
                  <CurrencyDisplay
                    value={remainingBalance}
                    decimalScale={2}
                    suffix=",-"
                    prefix="Rp "
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} my={1}>
                <SectionLabel title="Sales Invoice" mb="16px" />
                <CustomTable
                  isLoading={loadingTable}
                  columnTable={columnTableInvoiceSongDetail({
                    hideColumnPublisherRevenue: false,
                    hideColumnRemainingRevenue: false,
                    paymentComposer: false,
                  })}
                  data={dataTable}
                  page={tableParams?.page}
                  pageSize={tableParams?.size}
                  pageCount={tableTotalPage}
                  handleChangePage={(_, page) => {
                    handleChangeTableParams(page, "page");
                    triggerFetch.current = true;
                  }}
                  handleChangePageSize={e => {
                    handleChangeTableParams(e.target.value, "size");
                    triggerFetch.current = true;
                  }}
                  isHaveAction
                  tooltipView="View"
                  handleView={item => {
                    const selectedInv = selectedInvoices?.some(
                      selected =>
                        selected?.sales_invoice_id === item?.sales_invoice_id
                    );
                    const chosenInv = payload?.selected_sales_invoice?.find(
                      inv => inv?.sales_invoice_id === item?.sales_invoice_id
                    );
                    setModalVisible(true);
                    setSelectedInvoiceDetail({
                      ...item,
                      is_checked: selectedInv,
                      selected_item_ids: chosenInv?.selected_item_ids || [],
                    });
                  }}
                  isHaveCheckbox
                  checked={item =>
                    selectedInvoices?.some(
                      selected =>
                        selected?.sales_invoice_id === item?.sales_invoice_id
                    )
                  }
                  handleCheckbox={(e, item) =>
                    handleChangeCheckboxSalesInvoices(e, item)
                  }
                />
              </Grid>
              <Grid item xx={12} mb={1}>
                <SwitchInput
                  checked={showTaxes}
                  onChange={() => setShowTaxes(!showTaxes)}
                  label="Use taxes in this transaction"
                />
              </Grid>
              <Grid item xs={12}>
                {showTaxes && (
                  <CustomTable
                    columnTable={columnTableTaxes}
                    data={dataTableTaxes}
                    isHaveAction
                    checkedAction={item =>
                      selectedTaxes?.some(selected => selected?.id === item?.id)
                    }
                    rowClick={item => handleChangeCheckboxTaxes(null, item)}
                    handleCheckboxAction={(e, item) =>
                      handleChangeCheckboxTaxes(e, item)
                    }
                  />
                )}
                <Box bgcolor="#fafafa" borderRadius="6px" p="14px" mt="24px">
                  {showTaxes && (
                    <Box>
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item>Royalty</Grid>
                        <Grid item>
                          <Typography fontSize={18}>
                            <CurrencyDisplay
                              value={payload.value}
                              prefix={"Rp"}
                              decimalScale={2}
                              suffix=",-"
                            />
                          </Typography>
                        </Grid>
                      </Grid>
                      <Box mt="16px">
                        {checkSelectedTaxes &&
                          selectedTaxes?.map((item, index) => (
                            <Grid
                              container
                              key={index}
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item>{item?.code}</Grid>
                              <Grid item>
                                <Typography fontSize={18}>
                                  <CurrencyDisplay
                                    value={calculateSingleTax(
                                      item,
                                      payload.value
                                    )}
                                    prefix={selectedCurrencyCode}
                                    decimalScale={2}
                                    suffix=",-"
                                  />
                                </Typography>
                              </Grid>
                            </Grid>
                          ))}
                      </Box>
                      <Divider className={classes?.divider} />
                    </Box>
                  )}
                  {showCostAllocation && (
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      mt={2}
                    >
                      <Grid item>
                        <Typography fontSize="18px">Cost Allocation</Typography>
                      </Grid>
                      <Grid item>
                        <CurrencyNumberInput
                          disabled={
                            !payload?.composer_id ||
                            !payload?.value ||
                            loadingCostAllocation
                          }
                          placeholder="Cost Allocation"
                          value={payload?.cost_allocation_amount || 0}
                          startAdornment="Rp"
                          onChange={handleChangeCostAllocation}
                        />
                        <Grid justifyContent="flex-start" display="flex">
                          <FormLabel label=" Remaining Cost Allocation : " />
                          <CurrencyDisplay
                            value={unpaidCostAllocation}
                            decimalScale={2}
                            suffix=",-"
                            prefix="Rp "
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography fontSize="18px">
                        Total {payload?.type === "claim" ? "Fee" : "Royalty"}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography fontWeight="bold" fontSize="24px">
                        <CurrencyDisplay
                          value={
                            showTaxes
                              ? totalRevenueAfterTax
                              : payload?.value -
                                (payload?.cost_allocation_amount || 0)
                          }
                          prefix={selectedCurrencyCode}
                          decimalScale={2}
                          suffix=",-"
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box justifyContent="flex-end" display="flex">
                  <Grid container justifyContent="flex-end" spacing={1}>
                    <Grid item>
                      <PrimaryButton
                        type="button"
                        label="Save As Draft"
                        onClick={e => {
                          handleSubmitPayload(e, true);
                        }}
                        disabled={loadingPage || submmiting}
                        loading={loadingPage || submmiting}
                      />
                    </Grid>
                    <Grid item>
                      <PrimaryButton
                        type="button"
                        label="Send To Approval"
                        onClick={e => handleSubmitPayload(e, false)}
                        disabled={loadingPage || submmiting}
                        loading={loadingPage || submmiting}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}
      {modalVisible && (
        <ModalTable
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          title={`Sales Invoice : ${selectedInvoiceDetail?.sales_invoice_number ||
            "-"}`}
          isLoading={loadingTableModal}
          dataTable={dataTableModal}
          columnTable={columnModalTable}
          page={tableModalParams?.page}
          pageSize={tableModalParams?.size}
          pageCount={tableModalTotalPage}
          handleChangePage={(_, page) => {
            handleChangeTableModalParams(page, "page");
          }}
          handleChangePageSize={e =>
            handleChangeTableModalParams(e.target.value, "size")
          }
          isHaveAction
          checkedAction={item => {
            const selected = selectedInvoiceDetail?.selected_item_ids || [];

            const checkId = item?.item_id;
            return selected.includes(checkId);
          }}
          handleCheckboxAction={handleChangeCheckboxSong}
          buttonLabel="Apply"
          handleSubmit={handleSubmitSong}
          handleCancel
          search
          searchValue={tableModalParams?.search}
          handleSearch={e =>
            handleChangeTableModalParams(e.target.value, "search")
          }
        />
      )}
    </Page>
  );
}

const breadcrumbData = pageTitle => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Transaction",
    link: "/admin/sales-invoice",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const columnTableTaxes = [
  {
    name: "code",
    title: "Code",
  },
  {
    name: "description",
    title: "Description",
  },
  {
    name: "rate",
    title: "Rate",
    renderText: item => `${item} %`,
  },
];
const columnModalTable = [
  {
    name: "song_title",
    title: "Songs",
  },
  {
    name: "composer_remaining",
    title: "Composer Revenue (Remaining)",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
  {
    name: "paid_amount",
    title: "Paid",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
];

export default FormComposerInvoice;
